import React from "react";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { useTranslation } from "react-i18next";

const WithDocumentTitle = (Component: React.FC, title: string) => {
  const ComponentWithTitle: React.FC<any> = (props) => {
    const { t } = useTranslation();
    useDocumentTitle(t(title));
    return <Component {...props} />;
  };

  return ComponentWithTitle;
};

export default WithDocumentTitle;
